export class AssessmentTypeRequest {
    public memberCin: string;
    public calProviderId: string;
    public measurementPeriod: string;
    public assessmentCodes: string[] = [];
}